import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Header from './Header';
import { LinearProgress,  Typography} from "@material-ui/core";
import StyledButton from "./StyledButton";
import {useDispatch, useSelector} from "react-redux";
import {isRTL} from "../../utils";
import StyledTextField from "./StyledTextField";
import * as Actions from "../../redux/actions";
import Face from '@material-ui/icons/FaceRounded';
import ErrorIcon from "@material-ui/icons/Error";
import {Redirect} from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: 'rgba(247, 247, 249, 0.5)',
    },
    main: {
        background: '#FFFFFF',
        borderRadius: '2px',
        width: '310px',
        display: 'flex',
        margin: '10px auto',
        alignItems: 'center',
        flexDirection: 'column',
        paddingBottom: '60px',
    },
    blocksMargin : {
        width: '294px',
        marginTop: '10px',
        background: '#FFFFFF',
        borderRadius: '2px',
        border: '1px solid rgba(3, 2, 41, 0.03)',
    },
    titleBack: {
        color: '#9411AC',
        fontFamily: 'Nunito',
        fontSize: '9px',
        fontWeight: '700',
        fontStyle: 'normal',
        textDecoration: 'none',
        marginLeft: '10px',
        marginTop: '14px',
        cursor: "pointer",
    },
    titleBack2: {
        color: '#9411AC',
        fontFamily: 'Nunito',
        fontSize: '9px',
        fontWeight: '700',
        fontStyle: 'normal',
        textDecoration: 'none',
        marginLeft: '5px',
    },
    button: {
        width: '140px',
        margin: '4px'
    },
    buttonDone: {
        width: '40px',
        height: '20px',
        minWidth: 'auto',
        margin: '4px',
        borderRadius: '0',
        position: 'absolute',
        top: '10px',
        right: '0',
        zIndex: '1',
        textTransform: 'inherit',
        marginRight: '-72px',
    },
    buttonDelete: {
        position: 'absolute',
        top: '12px',
        right: '-32px',
        background: 'none',
        minWidth: 'auto',
        zIndex: '1',
        '&:hover': {
            background: 'none',
        },
    },
    list: {
        width: '100%'
    },
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        height: '32px',
        '&:hover' : {
            backgroundColor: 'rgba(36, 232, 255, 0.04)',
            cursor: 'pointer'
        },
        '&.Mui-selected': {
            backgroundColor: 'rgba(18, 116, 228, 0.05)'
        },
        '& > p': {
            flexGrow: 1,
            fontSize: '14px',
            fontFamily: 'Assistant'
        }
    },
    title: {
        color: '#030229',
        paddingTop: '14px',
        fontFamily: 'Nunito',
        fontSize: '10px',
        fontWeight: '800',
        fontStyle: 'normal',
    },
    title2: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '800',
        fontSize: '12px',
        color: '#030229',
        margin: '14px auto 0',
        textAlign: 'center',
        lineHeight: '24px',
    },
    description: {
        padding: '12px',
        fontFamily: 'Assistant',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        letterSpacing: '0.2px',
        color: '#595959',
        marginBottom: '10px'
    },
    progress: {
        marginTop :'12px',
        width: '74%'
    },
    deleteButton: {
        width: '11px',
        height: '11px',
    },
    deleteIcon: {
        width: '11px',
        height: '11px',
    },
    link: {
        padding: '0 20px',
        lineHeight: '33px',
        background: '#1174E5',
        textAlign: 'center',
        display: 'flex',
        margin: '0',
        textDecoration: 'none',
        alignItems: 'center',
        flexDirection: 'row',
        minWidth: '145px',
        boxSizing: 'border-box',
        justifyContent: 'center',
        '&:hover' : {
            backgroundColor: '#126DD5',
            cursor: 'pointer',
        },
    },
    span: {
        color: '#fff',
        paddingLeft: '8px',
        fontWeight: '700',
        fontSize:' 10px',
        fontFamily: 'Nunito',
    },
    textArea: {
        width: '294px',
        padding: '15px',
        boxSizing: 'border-box',
        background: 'rgba(247, 247, 249, 0.5)',
        border: '1px solid #F7F7F9',
        borderRadius: '2px',
        marginTop: '12px',
        marginBottom: '12px',
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '15px',
        letterSpacing: '-0.02em',
        color: '#030229',
    },
    titleKeep: {
        color: '#1174E5',
        fontFamily: 'Nunito',
        fontSize: '9px',
        fontWeight: '700',
        fontStyle: 'normal',
    },
    colorOne: {
        color: '#fff',
        textTransform: 'capitalize',
    },
    colorSecond: {
        color: '#00B298',
        textTransform: 'capitalize',
    },
    colorSecondOne: {
        color: '#030229',
        textTransform: 'capitalize',
    },
    bgOneClose :{
        border: 'none',
        width: '294px',
        background: '#D5D5D5',
        borderRadius: '2px',
        margin: '0',
        boxSizing: 'border-box',
        height: '33px',
        color: '#767676',
        '&:hover' : {
            backgroundColor: 'rgba(212, 212, 212, 0.75)',
            cursor: 'pointer'
        },
        '&:focus, &:active' : {
            backgroundColor: '#D5D5D5',
            cursor: 'pointer',
        },
        '&:focus span, &:focus svg path, &:active span, &:active svg path': {
            color: '#fff',
            fill:  '#fff',
        },
    },
    bgOneSave :{
        border: 'none',
        width: '294px',
        background: 'rgba(0, 178, 152, 0.15)',
        borderRadius: '0 0 2px 2px',
        margin: '0',
        marginBottom: '12px',
        boxSizing: 'border-box',
        height: '33px',
        color: '#fff',
        '&:hover' : {
            backgroundColor: 'rgba(0, 178, 152, 0.35)',
            cursor: 'pointer'
        },
        '&:focus, &:active' : {
            backgroundColor: 'rgba(0, 178, 152, 0.15)',
            cursor: 'pointer',
        },
        '&:focus span, &:focus svg path, &:active span, &:active svg path': {
            color: '#fff',
            fill:  '#fff',
        },
    },
    bgOne: {
        border: 'none',
        width: '294px',
        background: '#1174E5',
        borderRadius: '2px',
        margin: '0',
        boxSizing: 'border-box',
        height: '33px',
        color: '#fff',
        '&:hover' : {
            backgroundColor: 'rgba(17, 116, 229, 0.75)',
            cursor: 'pointer'
        },
        '&:focus, &:active' : {
            backgroundColor: '#1174E5',
            cursor: 'pointer',
        },
        '&:focus span, &:focus svg path, &:active span, &:active svg path': {
            color: '#fff',
            fill:  '#fff',
        },
    },
    bgSecond: {
        border: 'none',
        background: 'rgba(0, 178, 152, 0.15)',
        borderRadius: '2px',
        margin: '0',
        boxSizing: 'border-box',
        height: '33px',
        '&:hover' : {
            backgroundColor: 'rgba(0, 178, 152, 0.35)',
            cursor: 'pointer',
        },
        '&:focus, &:active' : {
            backgroundColor: 'rgba(0, 178, 152, 1)',
            cursor: 'pointer',
        },
        '&:focus span, &:focus svg path, &:active span, &:active svg path': {
            color: '#fff',
            fill:  '#fff',
        },
    },
    filter: {
        background: '#FFFFFF',
        borderRadius: '2px',
        width: '310px',
        height: '80px',
        margin: '0 auto',
        borderBottom: '1px solid rgba(3, 2, 41, 0.03)',
    },
    error: {
        background: 'rgba(247, 247, 249, 0.5)',
        border: '1px solid rgba(255, 89, 89, 0.15)',
        borderRadius: '2px',

        '&::placeholder': {
            color: 'rgba(255, 89, 89, 0.5)',
        },
    },
    noBg: {
        background: 'rgba(17, 116, 229, 0.15)',
        borderRadius: '2px',
        width: '34px',
        height: '24px',
        minWidth: 'auto',
        marginRight: '10px',
        marginTop: '10px',
        '&:hover': {
            background: 'rgba(17, 116, 229, 0.35)',
        },
    },
    noBgEdit: {
        background: 'none',
        position: 'absolute',
        right: '10px',
        minWidth: 'auto',
        marginRight: '-72px',
        cursor: 'pointer',
        '&:hover': {
            background: 'none',
        },
    },
    noBgEditClause: {
        background: 'none',
        position: 'absolute',
        right: '72px',
        top: '16px',
        minWidth: 'auto',
        marginRight: '-80px',
        cursor: 'pointer',
        zIndex: '2',
        '&:hover': {
            background: 'none',
        },
    },
    filterInput: {
        display: 'flex',
        margin: '4px 0 0 0',
        padding: '0 10px',
        width: '100%',
        boxSizing: 'border-box',
        position: 'relative',
    },
    filterHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
    },
    tags: {
        background: 'rgba(17, 116, 229, 0.15)',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '4.6875px 8.5px',
        margin: '2.5px',
        borderRadius: '6px',
        '& span' : {
            fontFamily: 'Nunito',
            fontStyle: 'normal',
            fontWeight: '600',
            fontSize: '9px',
            lineHeight: '12px',
            display: 'flex',
            alignItems: 'center',
            color: '#1174E5',
            opacity: '0.8',
            '& svg' : {
                width: '8px',
                height: '8px',
                marginLeft: '8px',
                cursor: 'pointer',
            }
        }
    },
    textField: {
        width: '100%',
        boxSizing: 'border-box',
        '& :before' : {
            display: 'none',
        },
        '& input' : {
            paddingLeft: '30px',
            boxSizing: 'border-box',
            height: '30px',
            fontFamily: 'Nunito',
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: '10px',
            color: '#030229',
            // borderBottom: '1px solid rgba(3, 2, 41, 0.03)',
            '& :before' : {
                display: 'none',
            },
        },
        '& input::placeholder': {
            color: '#030229',
            opacity: '1',
        },
    },
    tagsCategories: {
        padding: '12px',
        position:'relative',
        width: '190px',
    },
    clauseText :{
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '12px',
        color: '#030229',
        padding: '0 12px 6px 12px',
        borderBottom: '1px solid rgba(3, 2, 41, 0.03)',
    },
    clauseName : {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '8px',
        textDecoration: 'underline',
        color: '#1174E5',
    },
    clauseNameText: {
        marginLeft: '12px',
        alignSelf: 'center',
        cursor:"pointer",
    },
    clauseDocumentName: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '9px',
        display: "flex",
        marginLeft: '5px',
        color: '#030229',
        alignSelf: 'center',
    },
    clauseDocumentNameStyle: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '9px',
        color: '#030229',
        opacity: '0.5',
    },
    aiSuggests: {
        marginTop: '0',
    },
    aiSuggestsDisable:{
        background:'#D5D5D5',
    },
    styleForBlockSuggest: {
        display: 'flex',
        marginTop: '20px',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        boxSizing: 'border-box',
        flexDirection: "column",
    },
    textAreaResult: {
        width: '294px',
        padding: '15px',
        boxSizing: 'border-box',
        background: 'rgba(247, 247, 249, 0.5)',
        border: '1px solid rgba(0, 178, 152, 0.15)',
        borderBottom: 'none',
        borderRadius: '2px',
        marginBottom: '0',
        fontFamily: 'Nunito',
        margin: '0',
        color: '#030229',
        fontSize: '10px',
        fontWeight: '800',
        fontStyle: 'normal',
    },
    titleResult : {
        color: 'rgba(0, 178, 152, 1)',
        background: 'rgba(0, 178, 152, 0.15)',
        borderRadius: '4.2px 4.2px 1px 1px;',
        height: '22px',
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '10px',
        lineHeight: '14px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        width: '294px',
    },
    aiError: {
        background: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 89, 89, 0.1)',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.03)',
        borderRadius: '4px',
        width: '294px',
        boxSizing: 'border-box',
        marginBottom: '12px',
        fontFamily: 'Nunito',
        marginTop: '20px',
    },
    titleAiError: {
        color: '#FF5959',
        background: 'rgba(255, 89, 89, 0.15)',
        borderRadius: '4.2px 4.2px 1px 1px;',
        height: '22px',
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '10px',
        lineHeight: '14px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
    },
    aiErrorContent: {
        padding: '30px 20px 20px 20px',
    },
    aiErrorIcon: {
        display: 'flex',
        width: '100%',
        marginBottom: '15px',
    },
    aiErrorText : {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '11px',
        display: 'flex',
        alignItems: 'center',
        color: '#FF5959',
    },

    fixed: {
        bottom: '20px',
        position: 'fixed',
        background: '#fff',
    },
    textInternalNotes: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '12px',
        color: '#030229',
        width: '100%',
    },
    internalNotes:{
        width: '100%',
        boxSizing: 'border-box',
        padding: '10px',
    },
    closeInternalNotes: {
        float: 'right',
        marginRight: '10px',
        cursor: "pointer",
        marginBottom: '10px',
    },
    titleInternalNotes: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '11px',
        display: 'flex',
        color: '#030229',
        marginBottom: '10px',
    },
    readMore: {
        display: 'block',
        width: '100%',
        textAlign: 'right',
        cursor: 'pointer',
        marginTop: '5px',
        color: '#030229',
        textDecoration: 'underline',
    }
}));

export default function ClausesPorfolio({}) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(false);
    const clauseSearch = useSelector(state => state.document.clauseSearch)
    const clausesPortfolio = useSelector(state => state.document.clausesPortfolio)
    const [search, setSearch] = useState(undefined);
    const promptAi = useSelector(state => state.document.promptAi)
    const promptAiResult = useSelector(state => state.document.promptAiResult)
    const promptAiAction = useSelector(state => state.document.promptAiAction)
    const contextData = useSelector(state => state.document.contextData)
    const promptAiError = useSelector(state => state.document.promptAiError)
    const [result, setResult] = useState(promptAiResult);
    const [closed, setClosed] = useState(true);
    const [showInternalNotes, setShowInternalNotes] = useState(undefined);
    const [redirectPage, setRedirectPage] = useState(undefined);
    const [edit, setEdit] = useState('');
    const [openReadMore, setOpenReadMore] = useState('');
    const [alternativesText, setAlternativesText] = useState('');
    const [internalNotes, setInternalNotes] = useState('');

    function toRGBA(hex) {
        return "rgba(" + hex.match(/[^#]./g).map(ff => parseInt(ff, 16)) + ',0.15' + ")";
    }

    useEffect( () => {
        if(clauseSearch && clauseSearch.length > 1) {
            setSearch(clauseSearch)
        }
        const init = async () => {
            if(clauseSearch && clauseSearch.length > 1) {
                await setLoading(true);

                await dispatch(Actions.getClauses( clauseSearch ));
                await setLoading(false);

            } else if ( clauseSearch.length === 0){
                await setLoading(true);

                await dispatch(Actions.getClauses( '' ));
                await setLoading(false);
            }
        }
        init();
    }, [clauseSearch] );


    useEffect( () => {
        setResult(promptAiResult)
    }, [promptAiResult] );

    const handleClausesSearch = async () => {
        await dispatch(Actions.clauseSearch( search ));
    };

    const handleClose = async () => {
        setClosed(true)
    };

    const handleHideInternalNotes = async () => {
        setShowInternalNotes({})
    };

    const handleShowInternalNotes = async (id) => {
        setShowInternalNotes({id})
    };

    const saveInPortfolio = async () => {
        await dispatch(Actions.askAiMain( promptAiResult ));
        setRedirectPage('/keepClause')
    };

    function replaceWithBr(text) {
        return text.replace(/\n/g, "<br />")
    }

    const aiSuggests = async () => {
        await setLoading(true);
        await dispatch(Actions.askAi( `Prepare clause for ${clauseSearch}`, 'custom', '', contextData ));
        await setLoading(false);
        setClosed(false)
    };

    const handleEdditAskAiClick = async (clause) => {
        setEdit(clause.id)
        setAlternativesText(clause.alternatives && clause.alternatives.length && clause.alternatives[0].text );
        setInternalNotes(clause.alternatives && clause.alternatives.length && clause.alternatives[0].internal_notes );
    };

    const handleReadMoreClick = async (clause) => {
        setOpenReadMore(clause.id)
    };

    const handleReadMoreCloseClick = async (clause) => {
        setOpenReadMore('')
    };


    const handleDoneAskAiClick = async (id, index) => {
        setEdit('')
        await setLoading(true);
        const data = {
            "alternatives": [
                {
                    ...clausesPortfolio[index].alternatives[0],
                    "text": alternativesText,
                    "internal_notes": internalNotes,
                }
            ],
        }
        await dispatch(Actions.editClauses( id, data ));
        await dispatch(Actions.getClauses( '' ));
        await setLoading(false);
    };

    const handleDeleteClick = async (id) => {
        setEdit('')
        await setLoading(true);
        await dispatch(Actions.deleteClauses( id ));
        await setLoading(false);
    };
    const handleEdditClause = async (id) => {
        setRedirectPage(`/keepClauseEdit/${id}`)
    };

    const handleBack = async () => {
        setSearch(undefined);
        await dispatch(Actions.resetСlauseSearch());
        setRedirectPage(`/`)
    };

    const findTypeByLanguage = (tag, language) => {
        if(tag && tag.alternative_names.length){
            const correctNameIndex = tag.alternative_names.findIndex((n)=>{
                return n.language === language
            })
            if(correctNameIndex !==-1) {
                return tag.alternative_names[correctNameIndex].name
            }
        }
        return tag.name.name;
    }

    //console.log('clausesPortfolio', clausesPortfolio)

    return  redirectPage ? <Redirect to={redirectPage} /> :  (
        <div className={classes.root}>
            <Header showButton={false} />
            <div className={classes.filter}>
                <div className={classes.filterHeader}>
                    <span className={classes.titleBack} onClick={handleBack}>
                        <svg className={classes.svg} width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 5C9.27614 5 9.5 4.77614 9.5 4.5C9.5 4.22386 9.27614 4 9 4V5ZM0.646446 4.14645C0.451184 4.34171 0.451184 4.65829 0.646446 4.85355L3.82843 8.03553C4.02369 8.2308 4.34027 8.2308 4.53553 8.03553C4.7308 7.84027 4.7308 7.52369 4.53553 7.32843L1.70711 4.5L4.53553 1.67157C4.7308 1.47631 4.7308 1.15973 4.53553 0.964466C4.34027 0.769204 4.02369 0.769204 3.82843 0.964466L0.646446 4.14645ZM9 4L1 4V5L9 5V4Z" fill="#9411AC"/>
                        </svg>
                        <span className={classes.titleBack2}>Back</span>
                    </span>
                    <Typography className={classes.title2}>Clauses Portfolio Search</Typography>
                    <Tooltip title="Advanced search" arrow placement="bottom">
                        <StyledButton className={classes.noBg}>
                            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.58585 2.29167C1.4896 2.29167 1.39335 2.32833 1.31543 2.38792C1.11377 2.54375 1.0771 2.8325 1.23293 3.02958V3.03417L3.66668 6.15083V8.89625L4.71627 9.95042C4.89502 10.1292 5.18835 10.1292 5.3671 9.95042C5.54585 9.77167 5.54585 9.47833 5.3671 9.29958L4.58335 8.52042V5.83458L1.9571 2.47042C1.87002 2.35583 1.73252 2.29167 1.58585 2.29167ZM7.33335 5.5V9.11167C7.35168 9.24917 7.30585 9.39583 7.20043 9.49208C7.02168 9.67083 6.73293 9.67083 6.55418 9.49208L5.63293 8.57083C5.52752 8.46542 5.48168 8.32333 5.50002 8.19042V5.5H5.48627L2.84627 2.1175C2.69043 1.92042 2.7271 1.63167 2.92418 1.47583C3.01127 1.41167 3.10752 1.375 3.20835 1.375H9.62502C9.72585 1.375 9.8221 1.41167 9.90918 1.47583C10.1063 1.63167 10.1429 1.92042 9.9871 2.1175L7.3471 5.5H7.33335Z" fill="#1174E5"/>
                            </svg>
                        </StyledButton>
                    </Tooltip>
                </div>
                <div className={classes.filterInput}>
                   <span onClick={handleClausesSearch} style={{position: 'absolute', left: '16px', top: '5px', cursor: 'pointer', zIndex: '999'}}>
                        <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="4.09091" cy="4.09091" r="3.51818" stroke="#030229" stroke-width="1.14545"/>
                            <line x1="8.19004" y1="9" x2="6.54545" y2="7.35541" stroke="#030229" stroke-width="1.14545" stroke-linecap="round"/>
                        </svg>
                    </span>
                    <StyledTextField
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleClausesSearch()
                            }
                        }}
                        onChange={(e)=> {setSearch(e.target.value);}} value={search} type='text'
                        placeholder='Search a clause that contains…' name='filter'
                        className={classes.textField}>

                    </StyledTextField>
                </div>
            </div>
            <div className={classes.main}>

                {(isLoading) && <LinearProgress color="primary" className={classes.progress}/>}

                    {clausesPortfolio && clausesPortfolio.length > 0 && clausesPortfolio.map(( clause, index)=>{
                        return (
                            <div key={clause.id} className={classes.blocksMargin} style={{display: 'block' }} >
                                <div className={classes.tagsCategories}>
                                    { edit !== clause.id ?
                                        <Tooltip onClick={()=> {handleEdditAskAiClick(clause);}} className={classes.noBgEdit} title="edit clause" arrow placement="top">

                                                <svg className={classes.svg} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.0808 3.10666C11.3083 2.87916 11.3083 2.49999 11.0808 2.28416L9.71583 0.91916C9.5 0.69166 9.12083 0.69166 8.89333 0.91916L7.82 1.98666L10.0075 4.17416M0.75 9.06249V11.25H2.9375L9.38917 4.79249L7.20167 2.60499L0.75 9.06249Z" fill="#1174E5"/>
                                                </svg>

                                        </Tooltip>

                                        :
                                        <>
                                            <Tooltip onClick={()=> {handleEdditClause(clause.id);}} className={classes.noBgEditClause} title="edit tags / categories" arrow placement="top">
                                                <svg className={classes.svg} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.0808 3.10666C11.3083 2.87916 11.3083 2.49999 11.0808 2.28416L9.71583 0.91916C9.5 0.69166 9.12083 0.69166 8.89333 0.91916L7.82 1.98666L10.0075 4.17416M0.75 9.06249V11.25H2.9375L9.38917 4.79249L7.20167 2.60499L0.75 9.06249Z" fill="#1174E5"/>
                                                </svg>
                                            </Tooltip>

                                            <StyledButton onClick={()=> {handleDeleteClick(clause.id);}}
                                                          className={classes.buttonDelete}>
                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.91665 1.66667H6.45831L6.04165 1.25H3.95831L3.54165 1.66667H2.08331V2.5H7.91665M2.49998 7.91667C2.49998 8.13768 2.58778 8.34964 2.74406 8.50592C2.90034 8.6622 3.1123 8.75 3.33331 8.75H6.66665C6.88766 8.75 7.09962 8.6622 7.2559 8.50592C7.41218 8.34964 7.49998 8.13768 7.49998 7.91667V2.91667H2.49998V7.91667Z" fill="#FF5959"/>
                                                </svg>
                                            </StyledButton>
                                            <StyledButton onClick={()=> {handleDoneAskAiClick(clause.id, index);}} className={classes.buttonDone}>
                                                Done
                                            </StyledButton>
                                        </>
                                    }
                                   { clause.categories && clause.categories.length
                                    ? clause.categories.map((category)=>{
                                        return (
                                            <div dir={isRTL(category.name.name) ? 'rtl' : 'ltr'}
                                                 key={category.id}
                                                 className={classes.tags}
                                                 style={{display: 'inline-block'}}
                                            >
                                                <span>
                                                    {category.name.name}
                                                </span>
                                            </div>
                                        )
                                    }): null }

                                    { clause.tags && clause.tags.length
                                        ? clause.tags.map((tag)=>{
                                            return (
                                                <div
                                                    dir={isRTL(tag.name.name) ? 'rtl' : 'ltr'}
                                                    key={tag.id}
                                                    className={classes.tags}
                                                    style={{display: 'inline-block', background: `${toRGBA(tag.color ? tag.color : '#1174e5' )}` }}
                                                >
                                                    <span style={{color:`${tag.color}`}}>
                                                        {findTypeByLanguage(tag, clause.language)}
                                                    </span>
                                                </div>
                                            )
                                        }) : null }
                                </div>


                                { edit !== clause.id ?
                                    <div
                                        dir={clause.alternatives && clause.alternatives.length && clause.alternatives[0].text && isRTL(clause.alternatives[0].text) ? 'rtl' : 'ltr'}
                                        className={classes.clauseText}
                                    >
                                        { clause.alternatives && clause.alternatives.length && clause.alternatives[0].text.length > 400 ?
                                            openReadMore !== clause.id ?
                                            <>
                                                {clause.alternatives[0].text.substr(0, 400)}...
                                                <span onClick={()=> {handleReadMoreClick(clause);}} className={classes.readMore}>Show More</span>
                                            </>
                                                :
                                            <>
                                                {clause.alternatives[0].text}
                                                <span onClick={()=> {handleReadMoreCloseClick(clause);}} className={classes.readMore}>Show Less</span>
                                            </>

                                            : clause.alternatives[0].text
                                        }
                                    </div>
                                    :
                                    <div
                                        dir={clause.alternatives && clause.alternatives.length && clause.alternatives[0].text && isRTL(clause.alternatives[0].text) ? 'rtl' : 'ltr'}
                                    >
                                        <TextareaAutosize minRows={8}  name='prompt' className={ classes.textArea} value={ alternativesText }
                                              onChange={(e)=> {setAlternativesText(e.target.value);}}
                                        />
                                    </div>
                                }

                                <div
                                    style={{justifyContent: 'space-between',
                                        alignSelf: 'center',
                                        display: 'flex',
                                        alignContent: 'center',
                                        padding: '0 12px 0',
                                        boxSizing: 'border-box',
                                        height: '30px',
                                    }}
                                >
                                    <span className={classes.clauseName}
                                        style={{
                                            alignSelf: 'center',
                                            display: 'flex',
                                            alignContent: 'center'}}
                                    >

                                        <Tooltip title={clause.user.username} arrow placement="top">
                                            <Face fontSize="small" color="primary"/>
                                        </Tooltip>

                                        <span
                                            onClick={()=>{handleShowInternalNotes(clause.id)}}
                                            className={classes.clauseNameText}>
                                            Internal Note
                                        </span>

                                    </span>
                                    <span className={classes.clauseDocumentName}>
                                        <span className={classes.clauseDocumentNameStyle} style={{alignSelf: 'center'}}>{ clause.alternatives && clause.alternatives.length && clause.alternatives[0].name }</span>
                                        <svg style={{marginLeft: '12px', alignSelf: 'center',}} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_155_736)">
                                            <path d="M4.58325 3.74998H5.41659V2.91665H4.58325M4.99992 8.33331C3.16242 8.33331 1.66659 6.83748 1.66659 4.99998C1.66659 3.16248 3.16242 1.66665 4.99992 1.66665C6.83742 1.66665 8.33325 3.16248 8.33325 4.99998C8.33325 6.83748 6.83742 8.33331 4.99992 8.33331ZM4.99992 0.833313C4.45274 0.833313 3.91093 0.941087 3.4054 1.15048C2.89988 1.35988 2.44055 1.66679 2.05364 2.0537C1.27224 2.8351 0.833252 3.89491 0.833252 4.99998C0.833252 6.10505 1.27224 7.16486 2.05364 7.94626C2.44055 8.33317 2.89988 8.64008 3.4054 8.84948C3.91093 9.05887 4.45274 9.16665 4.99992 9.16665C6.10499 9.16665 7.1648 8.72766 7.9462 7.94626C8.7276 7.16486 9.16659 6.10505 9.16659 4.99998C9.16659 4.45281 9.05881 3.91099 8.84942 3.40547C8.64002 2.89994 8.33311 2.44061 7.9462 2.0537C7.55929 1.66679 7.09996 1.35988 6.59443 1.15048C6.08891 0.941087 5.54709 0.833313 4.99992 0.833313ZM4.58325 7.08331H5.41659V4.58331H4.58325V7.08331Z" fill="#1275E5"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_155_736">
                                            <rect width="10" height="10" fill="white"/>
                                            </clipPath>
                                            </defs>
                                        </svg>

                                    </span>
                                </div>



                                { edit !== clause.id ?
                                    showInternalNotes && showInternalNotes.id === clause.id ?
                                    <div
                                        dir={clause.alternatives && clause.alternatives.length && isRTL(clause.alternatives[0].internal_notes) ? 'rtl' : 'ltr'}
                                        className={classes.internalNotes}>
                                        {clause.alternatives && clause.alternatives.length && clause.alternatives[0].internal_notes &&
                                            <>
                                                <svg onClick={()=>{handleHideInternalNotes()}} className={classes.closeInternalNotes} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.25006 2.15937L5.34069 1.25L3.75006 2.84063L2.15944 1.25L1.25006 2.15937L2.84069 3.75L1.25006 5.34062L2.15944 6.25L3.75006 4.65937L5.34069 6.25L6.25006 5.34062L4.65944 3.75L6.25006 2.15937Z" fill="#6211E5"/>
                                                </svg>

                                                <p className={classes.textInternalNotes} dangerouslySetInnerHTML={{ __html:replaceWithBr(clause.alternatives[0].internal_notes) }} ></p>
                                            </>
                                        }
                                    </div> : null

                                    :

                                    showInternalNotes && showInternalNotes.id === clause.id ?
                                        <div
                                            dir={clause.alternatives && clause.alternatives.length && clause.alternatives[0].internal_notes && isRTL(clause.alternatives[0].internal_notes) ? 'rtl' : 'ltr'}
                                        >
                                            <svg style={{marginBottom: '0'}} onClick={()=>{handleHideInternalNotes()}} className={classes.closeInternalNotes} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.25006 2.15937L5.34069 1.25L3.75006 2.84063L2.15944 1.25L1.25006 2.15937L2.84069 3.75L1.25006 5.34062L2.15944 6.25L3.75006 4.65937L5.34069 6.25L6.25006 5.34062L4.65944 3.75L6.25006 2.15937Z" fill="#6211E5"/>
                                            </svg>
                                            <TextareaAutosize minRows={8}  name='prompt' className={ classes.textArea} value={ internalNotes }
                                                              onChange={(e)=> {setInternalNotes(e.target.value);}}
                                            />
                                        </div> : null
                                }

                            </div>

                        )

                    })}

                    <div className={classes.fixed}>
                        {
                            promptAiError && !isLoading && !closed
                                ?
                                <div className={classes.aiError}>
                                    <Typography className={classes.titleAiError}>
                                        <span style={{marginLeft: 'auto', order: '1'}}>AI Suggests!</span>
                                        <svg style={{marginLeft: 'auto', marginRight: '10px', order: '2'}} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.34078 4.09266C9.42637 3.83888 9.47002 3.57317 9.47007 3.30571C9.47004 2.86314 9.35056 2.42856 9.12392 2.04664C8.6685 1.26448 7.8237 0.781573 6.9094 0.781573C6.72928 0.781576 6.54966 0.800346 6.37353 0.837572C6.13663 0.574218 5.84584 0.363404 5.52034 0.219031C5.19484 0.074659 4.84202 7.69704e-06 4.48514 0H4.46911L4.4631 3.48928e-05C3.35572 3.48928e-05 2.37367 0.705082 2.03325 1.74448C1.68087 1.81569 1.34797 1.96036 1.05684 2.16879C0.765717 2.37722 0.523075 2.64461 0.345161 2.95306C0.119209 3.33728 0.000138266 3.77357 0 4.21778C8.63507e-05 4.84207 0.23495 5.44412 0.659114 5.90734C0.573493 6.16111 0.529826 6.42683 0.529789 6.69429C0.529829 7.13686 0.649306 7.57144 0.87594 7.95336C1.14545 8.41636 1.55703 8.78293 2.05132 9.00023C2.54561 9.21752 3.09707 9.27431 3.62619 9.16239C3.86312 9.42575 4.15393 9.63656 4.47945 9.78094C4.80498 9.92532 5.15782 9.99998 5.51472 10H5.53074L5.53725 9.99997C6.64524 9.99997 7.62697 9.29488 7.96739 8.25454C8.31977 8.18331 8.65266 8.03863 8.94379 7.83019C9.23492 7.62176 9.47758 7.35437 9.65551 7.04593C9.88122 6.66205 10.0001 6.22612 10 5.78232C9.99992 5.15805 9.76494 4.55587 9.34078 4.09266ZM5.53138 9.34624H5.52876C5.08541 9.34609 4.65614 9.19263 4.31559 8.91253C4.33581 8.90178 4.35579 8.89061 4.37553 8.87901L6.39349 7.72891C6.44384 7.70062 6.48572 7.65969 6.51485 7.61027C6.54399 7.56084 6.55934 7.50469 6.55936 7.44752V4.63854L7.4123 5.12448C7.41678 5.12668 7.42064 5.12994 7.42353 5.13396C7.42643 5.13799 7.42827 5.14266 7.4289 5.14756V7.4722C7.42773 8.50573 6.57893 9.34414 5.53138 9.34624ZM1.4507 7.62658C1.28402 7.34221 1.1962 7.01952 1.19608 6.69101C1.19608 6.58387 1.20557 6.47644 1.22404 6.37087C1.23904 6.37974 1.26522 6.39552 1.28401 6.40617L3.30197 7.55627C3.35228 7.58525 3.40949 7.60051 3.46775 7.6005C3.52601 7.60049 3.58321 7.5852 3.63351 7.5562L6.09723 6.15257V7.12448L6.09726 7.12615C6.09726 7.13083 6.09616 7.13545 6.09404 7.13964C6.09192 7.14382 6.08885 7.14747 6.08505 7.15028L4.04508 8.31243C3.75644 8.47634 3.42926 8.56265 3.09622 8.56275C2.76283 8.5627 2.43531 8.47617 2.1465 8.31185C1.85769 8.14752 1.61774 7.91127 1.4507 7.62658ZM0.919815 3.27984C1.14145 2.89999 1.49141 2.60916 1.90845 2.45822C1.90845 2.47536 1.90746 2.50573 1.90746 2.52682V4.82706L1.90742 4.82895C1.90743 4.88606 1.92276 4.94216 1.95185 4.99154C1.98094 5.04092 2.02276 5.08182 2.07305 5.11009L4.53677 6.51352L3.68386 6.99946C3.67965 7.0022 3.67482 7.00386 3.66981 7.00431C3.66479 7.00477 3.65973 7.00398 3.65509 7.00204L1.61491 5.83892C1.3265 5.67406 1.08707 5.43731 0.920611 5.15239C0.754151 4.86747 0.666511 4.54438 0.666473 4.21551C0.666601 3.88715 0.753884 3.56447 0.919815 3.27984ZM7.92759 4.88889L5.46387 3.48529L6.31681 2.99953C6.32102 2.99679 6.32585 2.99512 6.33087 2.99467C6.33589 2.99422 6.34094 2.995 6.34558 2.99695L8.38572 4.15909C8.67437 4.32369 8.91406 4.56031 9.08072 4.8452C9.24738 5.1301 9.33515 5.45324 9.33523 5.78218C9.33523 6.56732 8.8387 7.26985 8.09212 7.54101V5.17199L8.09222 5.16934C8.09221 5.11244 8.07698 5.05654 8.04807 5.0073C8.01916 4.95806 7.9776 4.91722 7.92759 4.88889ZM8.77653 3.62819C8.75669 3.6162 8.73671 3.60444 8.71659 3.59293L6.69863 2.44279C6.64831 2.41386 6.59113 2.39861 6.5329 2.39859C6.47466 2.39861 6.41748 2.41386 6.36716 2.44279L3.90341 3.84642V2.87451L3.90338 2.87283C3.90338 2.86334 3.90794 2.8544 3.91562 2.84871L5.95559 1.68754C6.24414 1.5234 6.57135 1.43699 6.90442 1.43698C7.95331 1.43698 8.80391 2.27626 8.80391 3.31119C8.80386 3.41739 8.7947 3.52351 8.77653 3.62819ZM3.43968 5.36045L2.58656 4.87451C2.58209 4.87231 2.57823 4.86905 2.57534 4.86502C2.57244 4.861 2.5706 4.85633 2.56997 4.85143V2.52675C2.57043 1.49238 3.42104 0.653796 4.46947 0.653796C4.91351 0.653887 5.34351 0.807371 5.68484 1.08761C5.66948 1.09589 5.6427 1.11048 5.6249 1.12113L3.60694 2.27123C3.55659 2.2995 3.51472 2.34041 3.48559 2.38982C3.45646 2.43922 3.44111 2.49536 3.4411 2.55252V2.55437L3.43968 5.36045ZM3.90302 4.37478L5.00032 3.74944L6.09761 4.37436V5.62463L5.00032 6.24959L3.90302 5.62463V4.37478Z" fill="#FF5959"/>
                                        </svg>
                                    </Typography>
                                    <div className={classes.aiErrorContent}>
                                        <ErrorIcon fontSize='large' htmlColor='rgba(255, 89, 89, 0.15)' className={classes.aiErrorIcon}/>
                                        <span className={classes.aiErrorText}>Error - please try to refresh or rephrase your search</span>
                                    </div>
                                </div>
                                :
                                promptAiResult && !isLoading && !closed ?
                                    <>
                                        <div className={classes.styleForBlockSuggest}>
                                            <Typography className={classes.titleResult}>
                                                <svg width="12" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.34078 4.09266C9.42637 3.83888 9.47002 3.57317 9.47007 3.30571C9.47004 2.86314 9.35056 2.42856 9.12392 2.04664C8.6685 1.26448 7.8237 0.781573 6.9094 0.781573C6.72928 0.781576 6.54966 0.800346 6.37353 0.837572C6.13663 0.574218 5.84584 0.363404 5.52034 0.219031C5.19484 0.074659 4.84202 7.69704e-06 4.48514 0H4.46911L4.4631 3.48928e-05C3.35572 3.48928e-05 2.37367 0.705082 2.03325 1.74448C1.68087 1.81569 1.34797 1.96036 1.05684 2.16879C0.765717 2.37722 0.523075 2.64461 0.345161 2.95306C0.119209 3.33728 0.000138266 3.77357 0 4.21778C8.63507e-05 4.84207 0.23495 5.44412 0.659114 5.90734C0.573493 6.16111 0.529826 6.42683 0.529789 6.69429C0.529829 7.13686 0.649306 7.57144 0.87594 7.95336C1.14545 8.41636 1.55703 8.78293 2.05132 9.00023C2.54561 9.21752 3.09707 9.27431 3.62619 9.16239C3.86312 9.42575 4.15393 9.63656 4.47945 9.78094C4.80498 9.92532 5.15782 9.99998 5.51472 10H5.53074L5.53725 9.99997C6.64524 9.99997 7.62697 9.29488 7.96739 8.25454C8.31977 8.18331 8.65266 8.03863 8.94379 7.83019C9.23492 7.62176 9.47758 7.35437 9.65551 7.04593C9.88122 6.66205 10.0001 6.22612 10 5.78232C9.99992 5.15805 9.76494 4.55587 9.34078 4.09266ZM5.53138 9.34624H5.52876C5.08541 9.34609 4.65614 9.19263 4.31559 8.91253C4.33581 8.90178 4.35579 8.89061 4.37553 8.87901L6.39349 7.72891C6.44384 7.70062 6.48572 7.65969 6.51485 7.61027C6.54399 7.56084 6.55934 7.50469 6.55936 7.44752V4.63854L7.4123 5.12448C7.41678 5.12668 7.42064 5.12994 7.42353 5.13396C7.42643 5.13799 7.42827 5.14266 7.4289 5.14756V7.4722C7.42773 8.50573 6.57893 9.34414 5.53138 9.34624ZM1.4507 7.62658C1.28402 7.34221 1.1962 7.01952 1.19608 6.69101C1.19608 6.58387 1.20557 6.47644 1.22404 6.37087C1.23904 6.37974 1.26522 6.39552 1.28401 6.40617L3.30197 7.55627C3.35228 7.58525 3.40949 7.60051 3.46775 7.6005C3.52601 7.60049 3.58321 7.5852 3.63351 7.5562L6.09723 6.15257V7.12448L6.09726 7.12615C6.09726 7.13083 6.09616 7.13545 6.09404 7.13964C6.09192 7.14382 6.08885 7.14747 6.08505 7.15028L4.04508 8.31243C3.75644 8.47634 3.42926 8.56265 3.09622 8.56275C2.76283 8.5627 2.43531 8.47617 2.1465 8.31185C1.85769 8.14752 1.61774 7.91127 1.4507 7.62658ZM0.919815 3.27984C1.14145 2.89999 1.49141 2.60916 1.90845 2.45822C1.90845 2.47536 1.90746 2.50573 1.90746 2.52682V4.82706L1.90742 4.82895C1.90743 4.88606 1.92276 4.94216 1.95185 4.99154C1.98094 5.04092 2.02276 5.08182 2.07305 5.11009L4.53677 6.51352L3.68386 6.99946C3.67965 7.0022 3.67482 7.00386 3.66981 7.00431C3.66479 7.00477 3.65973 7.00398 3.65509 7.00204L1.61491 5.83892C1.3265 5.67406 1.08707 5.43731 0.920611 5.15239C0.754151 4.86747 0.666511 4.54438 0.666473 4.21551C0.666601 3.88715 0.753884 3.56447 0.919815 3.27984ZM7.92759 4.88889L5.46387 3.48529L6.31681 2.99953C6.32102 2.99679 6.32585 2.99512 6.33087 2.99467C6.33589 2.99422 6.34094 2.995 6.34558 2.99695L8.38572 4.15909C8.67437 4.32369 8.91406 4.56031 9.08072 4.8452C9.24738 5.1301 9.33515 5.45324 9.33523 5.78218C9.33523 6.56732 8.8387 7.26985 8.09212 7.54101V5.17199L8.09222 5.16934C8.09221 5.11244 8.07698 5.05654 8.04807 5.0073C8.01916 4.95806 7.9776 4.91722 7.92759 4.88889ZM8.77653 3.62819C8.75669 3.6162 8.73671 3.60444 8.71659 3.59293L6.69863 2.44279C6.64831 2.41386 6.59113 2.39861 6.5329 2.39859C6.47466 2.39861 6.41748 2.41386 6.36716 2.44279L3.90341 3.84642V2.87451L3.90338 2.87283C3.90338 2.86334 3.90794 2.8544 3.91562 2.84871L5.95559 1.68754C6.24414 1.5234 6.57135 1.43699 6.90442 1.43698C7.95331 1.43698 8.80391 2.27626 8.80391 3.31119C8.80386 3.41739 8.7947 3.52351 8.77653 3.62819ZM3.43968 5.36045L2.58656 4.87451C2.58209 4.87231 2.57823 4.86905 2.57534 4.86502C2.57244 4.861 2.5706 4.85633 2.56997 4.85143V2.52675C2.57043 1.49238 3.42104 0.653796 4.46947 0.653796C4.91351 0.653887 5.34351 0.807371 5.68484 1.08761C5.66948 1.09589 5.6427 1.11048 5.6249 1.12113L3.60694 2.27123C3.55659 2.2995 3.51472 2.34041 3.48559 2.38982C3.45646 2.43922 3.44111 2.49536 3.4411 2.55252V2.55437L3.43968 5.36045ZM3.90302 4.37478L5.00032 3.74944L6.09761 4.37436V5.62463L5.00032 6.24959L3.90302 5.62463V4.37478Z" fill="#10A37F"/>
                                                </svg>
                                                <span style={{marginLeft: '8px'}}>AI suggests:</span>
                                            </Typography>
                                            <div className={classes.textAreaResult}>
                                                <span>{result}</span>
                                            </div>
                                            <StyledButton  onClick={saveInPortfolio} className={classes.button + ' ' + classes.bgOneSave + ' ' + classes.aiSuggests}>
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.500122" y="0.5" width="11" height="11" rx="3.5" fill="#F7F7F9" stroke="#EDEDED"/>
                                                    <rect x="2.00012" y="2" width="8" height="8" rx="3" fill="#00B298"/>
                                                </svg>


                                                <span className={classes.span   + ' ' + classes.colorSecondOne }>Save in Portfolio</span>
                                            </StyledButton>
                                        </div>
                                    </> : null

                        }

                        <div style={{display: 'flex', width: '294px', justifyContent: 'space-between',}}>
                            {closed ?
                                <StyledButton disabled= {!clauseSearch} onClick={aiSuggests} className={
                                    classes.button + ' ' + classes.bgOne + ' ' + classes.aiSuggests + ' ' + `${!clauseSearch ? classes.aiSuggestsDisable : ''}`
                                }>
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.4854 12.3179L8.755 15.5621V13.0333L12.325 11.0712L14.4854 12.3179ZM14.875 11.9637V5.17791L12.7783 6.375V10.7525L14.875 11.9637ZM2.51458 12.3179L8.245 15.555V13.0333L4.675 11.0712L2.51458 12.3179ZM2.125 11.9637V5.17791L4.22167 6.375V10.7525L2.125 11.9637ZM2.37292 4.73875L8.245 1.41666V3.86041L4.48375 5.92875L4.44833 5.94291L2.37292 4.73875ZM14.6271 4.73875L8.755 1.41666V3.86041L12.5162 5.93583L12.5446 5.95L14.6271 4.73875ZM8.245 12.4596L4.72458 10.5187V6.68666L8.245 8.71958V12.4596ZM8.755 12.4596L12.2754 10.5258V6.68666L8.755 8.71958V12.4596ZM4.95833 6.24041L8.5 4.2925L12.0417 6.24041L8.5 8.28041L4.95833 6.24041Z" fill="white"/>
                                    </svg>

                                    <span className={classes.span   + ' ' + classes.colorOne }>AI Suggests</span>
                                </StyledButton>
                                : <>
                                    <StyledButton style={{marginRight: '10px'}} onClick={handleClose} className={classes.button + ' ' + classes.bgOneClose + ' ' + classes.aiSuggests}>
                                        <span style={{color:'#767676'}} className={classes.span   + ' ' + classes.colorOne }>Close</span>
                                    </StyledButton>

                                    <StyledButton onClick={aiSuggests} className={classes.button + ' ' + classes.bgOne + ' ' + classes.aiSuggests}>
                                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.4596 10.2375C10.6979 9.86377 10.8333 9.41419 10.8333 8.93752C10.8333 7.58336 9.75 6.50002 8.39583 6.50002C7.04167 6.50002 5.95833 7.58336 5.95833 8.93752C5.95833 10.2917 7.04167 11.375 8.39583 11.375C8.86708 11.375 9.31125 11.2396 9.685 11.0067L11.375 12.6696L12.1279 11.9167L10.4596 10.2375ZM8.39583 10.2917C7.64833 10.2917 7.04167 9.68503 7.04167 8.93752C7.04167 8.19002 7.64833 7.58336 8.39583 7.58336C9.14333 7.58336 9.75 8.19002 9.75 8.93752C9.75 9.68503 9.14333 10.2917 8.39583 10.2917ZM5.19458 10.4L1.625 7.62127L2.5025 6.93878L4.875 8.78586C4.875 8.84002 4.875 8.88877 4.875 8.93752C4.875 9.45753 4.99417 9.95586 5.19458 10.4ZM2.50792 5.56294L1.625 4.87503L6.5 1.08336L11.375 4.87503L10.4867 5.56294L10.1021 5.86086C9.59833 5.57919 9.01333 5.41669 8.39583 5.41669C6.92792 5.41669 5.66583 6.32669 5.14583 7.61044L2.50792 5.56294Z" fill="white"/>
                                        </svg>

                                        <span className={classes.span   + ' ' + classes.colorOne }>ReSuggests</span>
                                    </StyledButton>
                                </>
                            }


                        </div>
                    </div>





            </div>



            <div style={{display: 'flex', height: '1px'}}></div>
        </div>
    );
}

